module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-content"
  }, [_c('div', {
    staticClass: "no-content-img"
  }), _vm._v(" "), _c('p', {
    staticClass: "no-content-text"
  }, [_vm._v("哎呀，页面未找到！")]), _vm._v(" "), _c('router-link', {
    staticClass: "link-btn",
    attrs: {
      "to": '/'
    }
  }, [_vm._v("返回首页")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3f1c2b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/error/404.vue
// module id = 416
// module chunks = 68